const moment = require('moment');
const { default: AggConstants } = require('../../constants/AggConstants');
const { default: TipoAtributo } = require('../../constants/TipoAtributo');
const { SPLIT_CHAR_MULTI } = require('../../constants/Split');
const { default: SystemConstants } = require('../../common/SystemConstants');
const FiltroConstants = require('../../constants/FiltroConstants').default;
const Atributos = require('../../common/Atributos');
function capitalizeFirstLetter(string) {
    const [first, ...rest] = string;
    return first.toUpperCase() + rest.join('');
}
module.exports = {
    cubo: 'cubo_fichas',
    title: SystemConstants.Strings.paginas.dadosExposicaoVitimaHumanaDadosPorGrupoEClasseDosAgentes,
    primeiraConsultaAutomatica: true,
    atributosSelecionados: [
        Atributos.GRUPO_CLASSE,
        Atributos.SUBCLASSE_SUBSTANCIA,
        Atributos.F_AGENTE_CLASSE_DESCRICAO_COMB,
        // Atributos.QNT, // Sempre colocar o último atributo como métrica.
    ],
    // nextPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_E_CLASSE_DOS_AGENTES,
    backPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_DE_AGENTES,
    charts: [
        {
            title: 'CLASSE DOS AGENTES',
            description: 'Classe dos Agentes.',
            w: 6,
            type: 'Pivottable',
            preFlatMap: {
                dimension: Atributos.GRUPO_CLASSE,
                flatFn: (grupo_classe) => {
                    return grupo_classe;
                },
            },
            addAttribute: {
                genDimensions: ['Grupo', 'Classe'],
                valueFn: (grupo_classe) => {
                    // console.log(grupo_classe, 'grupo_classe[0]');
                    if (!grupo_classe || grupo_classe === 'Não preenchido')
                        return ['Não preenchido', 'Não preenchido'];
                    const dims = grupo_classe === null || grupo_classe === void 0 ? void 0 : grupo_classe.split(' | ');
                    if (dims.length === 1)
                        return [dims[0], 'Não preenchido'];
                    return dims;
                },
                attributes: [Atributos.GRUPO_CLASSE],
            },
            postFilters: (filtrosSecundarios) => {
                console.log(filtrosSecundarios, 'filtrosSecundarios');
                const filtroSelecionado = filtrosSecundarios.find((filtro) => (filtro === null || filtro === void 0 ? void 0 : filtro.atributo) === Atributos.GRUPO);
                let valores = [];
                if ((filtroSelecionado === null || filtroSelecionado === void 0 ? void 0 : filtroSelecionado.valor) && filtroSelecionado.valor !== '') {
                    valores = filtroSelecionado === null || filtroSelecionado === void 0 ? void 0 : filtroSelecionado.valor.toUpperCase().split(SPLIT_CHAR_MULTI);
                }
                console.log(valores, 'valores');
                return [
                    {
                        attribute: 'Grupo',
                        filter: (value) => {
                            // console.log(value, 'value');
                            if (valores.length === 0)
                                return true;
                            if (valores.includes(value))
                                return true;
                            return false;
                        },
                    },
                ];
            },
            selectDimensions: ['Grupo', 'Classe', Atributos.QNT],
            headers: ['Grupo', 'Classe', 'Quantidade'],
            rows: ['Grupo', 'Classe'],
            rowOrder: 'value_z_to_a',
            // aggregatorName: 'Integer Sum',
            aggregatorList: [
                {
                    vals: ['Quantidade'],
                    aggTitle: 'Quantidade',
                    aggregatorName: 'Integer Sum',
                },
                {
                    vals: ['Quantidade'],
                    aggTitle: '%',
                    aggregatorName: 'Sum as Fraction of Total',
                },
            ],
            enablePercentage: true,
            vals: ['Quantidade'],
            cols: [],
            filters: [],
            transformations: [],
        },
        {
            title: 'SUBCLASSE DOS AGENTES',
            description: 'Subclasse dos Agentes.',
            w: 6,
            type: 'Pivottable',
            preFlatMap: {
                dimension: Atributos.SUBCLASSE_SUBSTANCIA,
                flatFn: (subclasse_substancia) => {
                    return subclasse_substancia;
                },
            },
            addAttribute: {
                genDimensions: ['Subclasse', 'Substância'],
                valueFn: (subclasse_substancia) => {
                    if (Array.isArray(subclasse_substancia)) {
                        console.log(subclasse_substancia, 'subclasse_substancia[0]');
                        subclasse_substancia = subclasse_substancia[0];
                    }
                    if (!subclasse_substancia || subclasse_substancia === 'Não preenchido')
                        return ['Não preenchido', 'Não preenchido'];
                    const dims = subclasse_substancia === null || subclasse_substancia === void 0 ? void 0 : subclasse_substancia.split(' | ');
                    if (dims.length === 1)
                        return [dims[0], 'Não preenchido'];
                    return dims;
                },
                attributes: [Atributos.SUBCLASSE_SUBSTANCIA],
            },
            postFilters: (filtrosSecundarios) => {
                const filtroSelecionado = filtrosSecundarios.find((filtro) => (filtro === null || filtro === void 0 ? void 0 : filtro.atributo) === Atributos.SUBCLASSE);
                let valores = [];
                if ((filtroSelecionado === null || filtroSelecionado === void 0 ? void 0 : filtroSelecionado.valor) && filtroSelecionado.valor !== '') {
                    valores = filtroSelecionado === null || filtroSelecionado === void 0 ? void 0 : filtroSelecionado.valor.toUpperCase().split(SPLIT_CHAR_MULTI);
                }
                return [
                    {
                        attribute: 'Subclasse',
                        filter: (value) => {
                            if (valores.length === 0)
                                return true;
                            if (valores.includes(value))
                                return true;
                            return false;
                        },
                    },
                ];
            },
            selectDimensions: ['Subclasse', 'Substância', Atributos.QNT],
            headers: ['Subclasse', 'Substância', 'Quantidade'],
            rows: ['Subclasse', 'Substância'],
            rowOrder: 'value_z_to_a',
            aggregatorList: [
                {
                    vals: ['Quantidade'],
                    aggTitle: 'Quantidade',
                    aggregatorName: 'Integer Sum',
                },
                {
                    vals: ['Quantidade'],
                    aggTitle: '%',
                    aggregatorName: 'Sum as Fraction of Total',
                },
            ],
            enablePercentage: true,
            vals: ['Quantidade'],
            cols: [],
            filters: [],
            transformations: [],
        },
    ],
    metaAtributos: [
        {
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            grupo: 'Nome do centro',
            rotulo: 'Nome do centro',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            grupo: 'Ano de atendimento',
            rotulo: 'Ano de atendimento',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            grupo: 'Tipo de Ficha',
            rotulo: 'Tipo de Ficha',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            grupo: 'UF Solicitante',
            rotulo: 'UF Solicitante',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.GRUPO,
            atributoAgrupado: Atributos.GRUPO_CLASSE,
            grupo: 'Grupo de agentes',
            rotulo: 'Grupo de agentes',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.SUBCLASSE,
            atributoAgrupado: Atributos.SUBCLASSE_SUBSTANCIA,
            grupo: 'Subclasse de agentes',
            rotulo: 'Subclasse de agentes',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.CLASSE,
            grupo: 'Classe de agentes',
            rotulo: 'Classe de agentes',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_SEXO,
            grupo: 'Paciente: Sexo',
            rotulo: 'Paciente: Sexo',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            grupo: 'Paciente: Faixa etária',
            rotulo: 'Paciente: Faixa etária',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            grupo: 'Exposição: Circunstância',
            rotulo: 'Exposição: Circunstância',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO,
            grupo: 'Classificação de Gravidade Final',
            rotulo: 'Classificação de Gravidade Final',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            grupo: 'Desfecho',
            rotulo: 'Desfecho',
            tipo: 'TEXTO',
        },
    ],
    preFiltrosServer: [
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            tipoComponente: 'IN_SELECT',
            valor: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].join(FiltroConstants.SPLIT_VALUES),
        },
    ],
    filtros: [
        {
            key: 0,
            disabled: true,
            hidden: true,
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            rotulo: 'Tipo de ficha',
            tipoComponente: 'IN_SELECT',
            valor: 'Humana',
        },
        {
            key: 1,
            size: 2,
            disabled: true,
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            rotulo: 'Ano do atendimento',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 2,
            size: 2,
            disabled: false,
            atributo: Atributos.GRUPO,
            rotulo: 'Grupo de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 9,
            size: 2,
            disabled: false,
            atributo: Atributos.CLASSE,
            rotulo: 'Classe de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        // {
        //     key: 10,
        //     size: 2,
        //     disabled: false,
        //     atributo: Atributos.SUBCLASSE,
        //     rotulo: 'Subclasse de agentes',
        //     tipoComponente: 'IN_SELECT',
        //     valor: '',
        // },
        {
            key: 3,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_SEXO,
            rotulo: 'Sexo',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 4,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            rotulo: 'Faixa etária',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 5,
            size: 2,
            disabled: true,
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            rotulo: 'UF Solicitante',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 6,
            size: 2,
            disabled: false,
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            rotulo: 'Nome do centro',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 7,
            size: 2,
            disabled: false,
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            rotulo: 'Circunstância',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 8,
            size: 2,
            disabled: false,
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            rotulo: 'Desfecho',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
    ],
};
